import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@/components/ThemeProvider";

import "./index.less";

export default function PageHeader({ title, actions }) {
  const { isDarkMode } = useTheme();

  return (
    <div className={`page-header-wrapper ${isDarkMode ? 'dark-mode' : ''}`}>
      <h3>{title}</h3>
      {actions && (
        <div className={`page-header-actions ${isDarkMode ? 'dark-mode' : ''}`}>
          {actions}
        </div>
      )}
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.node,
};

PageHeader.defaultProps = {
  title: "",
  actions: null,
};
